import { Component, OnInit } from '@angular/core';
import { Contact } from '../../../../common/models/contact';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';
import { PersonalDataService } from '../../personalData/personal-data.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { BenefitFormComponent } from '../benefit-form/benefit-form.component';
import { environment } from '../../../../../environments/environment';
import { DialogService } from '../../../../common/shared/services/dialog.service';

@Component({
  selector: 'app-benefit-view',
  templateUrl: './benefit-view.component.html',
})
export class BenefitViewComponent implements OnInit {
  public contact: Contact;

  constructor(
    private _matDialog: MatDialog,
    private _utilitiesService: UtilitiesService,
    private _personalDataService: PersonalDataService,
    private _dialogService: DialogService,
    private _translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.contact = new Contact;
    this.loadContact();
  }

  loadContact() {
    this._personalDataService.loadContact().subscribe(
      data => {
        this.contact = this._utilitiesService.getData(data);
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  change() {
    const dialogRef = this._matDialog.open(BenefitFormComponent, {
      width: environment.MatDilalogWidth,
      data: {contact: this.contact}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Success') {
        this.loadContact();
        this._translateService.get(['portal.Profile.Subscription.Update.Success']).subscribe((res: string) => {
          this._dialogService.showSuccessDialog(res['portal.Profile.Subscription.Update.Success']);
        });
      } else if (result === 'Error') {
        this._translateService.get(['portal.Profile.PersonalData.Update.Error']).subscribe((res: string) => {
          this._dialogService.showErrorDialogWithBody(res['portal.Profile.PersonalData.Update.Error']);
        });
      }
    });
  }
}

